<template>
    <b-form-tag
        :class="['date-badge', 'mr-2', {'has-series': hasSeries}, {'no-series': !hasSeries}]"
        class="mb-2"
        :title="date"
        @remove="$emit('badge-remove', index)"
    ></b-form-tag>
</template>

<script>

    /**
     * This is a date item, showing a single
     * date (out of 5) for inclinometer chart
     * data.
     */

    export default {
        name: "DateBadge",
        props: {
            date: {
                type: [String, Number, Date],
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            hasSeries: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/mixins";

    .date-badge {
        display: inline-block;
        padding: 0.25rem 0.50rem;
        color: $whiteColor;
        border-radius: 5px;
        &.has-series {
            background-color: $purpleColor;
        }
        &.no-series {
            background-color: $mediumGrey;
        }
    }
</style>